export const TRANSLATIONS_AR = {
    home: "الرئيسية",
    about: "من نحن",
    services: "خدماتنا",
    why: "مايميزنا",
    clients: "عملائنا",
    heroTitle: "كن محور اهتمامنا",
    heroContent: "تك برو شركة يمنية متخصصة في تقنيات التطوير والتسويق بمختلف المجالات",
    aboutUsTitle: "من نحن؟",
    aboutUsContent: `تك برو شركة يمنية متخصصة في تقنيات التطوير والتسويق بمختلف المجالات، من خلال توفير كافة الحلول الترويجية والإعلانية، وإنجازها بأعلى مستوى من الابتكار والإبداع والاحترافية.

تلبِّي تطلُّعات رجال المال والأعمال، وتواكب التطور التكنولوجي المتسارع، وتضع فريقاً متكاملاً بخبرة طويلة وكفاءة عاليةتك برو شركة يمنية متخصصة في تقنيات التطوير والتسويق بمختلف المجالات، من خلال توفير كافة الحلول الترويجية والإعلانية، وإنجازها بأعلى مستوى من الابتكار والإبداع والاحترافية`,
    vision: "رؤيتنا",
    visionContent: `الشركة الأولى في تقديم أحدث وأرقى تقنيات التسويق والحلول الإبداعية`,
    message: "رسالتنا",
    messageContent: `تترسيخ الثقة بيننا وبين عملائنا، تقديم خدمات تسويقية عالية الجودة، دقَّة المواعيد`,
    servicesTitle: "خدماتنا",

    marketingT: `التسويق الألكتروني
`,
    marketingC: `نقدم خدمات التسويق الإلكتروني عبر مواقع التواصل الاجتماعي بشكل أكثر جودة وإبداعاً، لنعزز الوعي بعلامتك التجارية، بمحتوى وتصميم مبتكر وهادف، حيث يتم إدارة الحسابات بمهنية واحترافية عالية، وإدارة الحملات المدفوعة عبر جوجل، فيس بوك، تويتر، يوتيوب، ويتم رصد النتائج في تقارير احترافية تصلكم أولاً بأول، لضمان الظهور الفعال عبر محركات البحث، وضمان تحقيق النتائج الإيجابية المستهدفةنقدم خدمات التسويق الألكتروني عبر مواقع التواصل الاجتماعي بشكل اكثر جودة وابداعا, لنعزز الوعي بعلامتك التجارية, بمحتوى وتصميم مبتكر وهادف, حيث يتم ادارة الحسابات بمهنية واحترافية عاليةو وادارة الحملات المدفوعة عبر جوجل والفيس بوك, تويتر, يوتيوب, ويتم رصد النتائج في تقارير احترافية تصلكم أولا بأول, لضمان الظهور الفعال عبر محركات البحث لضمان تحقيق النتئج الاجابية المستهدفة.`,
    onlineMarketingT: `خدمات التسويق الرقمي المتكامل
`,
    onlineMarketingC: `نمنحك فرصة للتركيز على دورك الأساسي في رعاية مشروعك ونتولى نحن مهمة إدارة حساباتك التجارية على المنصات الرقمية، وفق خطة تسويقية تناسب نشاطك على شبكات التواصل الاجتماعي، ومراقبة وتحليل النتائج وتحسينها بالشكل الذي يحقق انتشارك ويحقق النتائج المطلوبة ويصل للشريحة المستهدفة.

`,
    journalismT: `خدمات التغطية الاعلامية
`,
    journalismC: `نقوم برصد وتوثيق الفعاليات والمناسبات (فيديو - فوتوجراف) وتغطيتها عبر شتى وسائل الإعلام، مع إضافة مواد إخبارية ترويجية لمشروعك.

`,
    fullJournalismContentT: `اعداد مواد اعلانية متكاملة
`,
    fullJournalismContentC: `صناعة فلاشات مرئية ومسموعة بأساليب وأفكار متنوعة (تعريفية - ترويجية) تُنشَر على منصات التواصل الاجتماعي الخاصة بمنشورك، ويتم بثها على وسائل إعلانيى مختلفة تتوافق مع الجمهور المستمع والمشاهد.صناعة فلاشات مرئية ومسموعة بأساليب وأفكار متنوعة (تعريفية - ترويجية) تنشر على منصات التواصل الأجتماعي الخاصة بمنشورك, ويتم بثها على وسائل أعلانية مختلفة تتوافق مع الجمهور المستمع والمشاهد.

`,
    giftsT: `تجهيز الهدايا الدعائية بأنواعها
`,
    giftsC: `نعمل على توفير الهدايا الدعائية بأفكار جديدة ومناسبة لنشاطك التجاري، ومميزة في إيصال.

`,
    designT: `خدمات التصميم
`,
    designC: `نقدم الصورة بفن وإبداع ومهارة، بالألوان المناسبة، لندهش عملاءك ونوصل رسالتك العميقة ببساطة، ونعزز صورتك بالتصاميم الإبداعية بِهُويَّة تُعبِّر عنك.نقدم الصورة بفن وابداع ومهارة, بالألوان المناسبة, لندهش عملائك ونوصل رسالتك العميقة ببساطة, ونعزز صورتك بالتصاميم الابداعية بهوية تعبر عنك.

`,
    codingT: `تصميم وبرمجة مواقع الانترنت
`,
    codingC: `رؤية جديدة في تصميم المواقع لتناسب هويتك التجارية بتصميم يسهل به الوصول للعملاء، وبما يتناسب مع محركات البحث، وجميع متصفحات الإنترنت، وأجهزة الجوال والتابلترؤية جديدة في تصميم المواقع لتناسب هويتك التجارية بتصميم يسهل به الوصول للعملاء وبما يتناسب مع محركات البحث وجميع متصفحات الانترنت, وأجهزة الجوال والتابلت.

`,
    printT: `خدمات الطباعة
`,
    printC: `تنفيذ أعمال وخدمات الطباعة المتكاملة بمختلف أنواعها (ورقية - إعلانية - دعائية) باستخدام أحدث تكنولوجيا الطباعة المستدامة.تنفيذ أعمال وخدمات الطباعة المتكاملة بمختلف أنواعها (ورقية - اعلانية - داعئية) باستخدام أحدث تكنولوجيا الطباعة المستدامة.

`,
    studyT: `تنفيذ الدراسات وقياس الرأي العام
`,
    studyC: `نعمل على دراسات استطلاعية للجمهور, بأدوات بحثية منهجية تضعك امام النجاحات التي حققه مشروعك, كما تضع خططا استراتيجية ترويجية لتطوير المشروع وتحقيق نجاحات مستقبلية مبنية على نتائج تلك الاستطلاعات.

`,
    seoT: `رفع ترتيب المواقع في محركات البحث
`,
    seoC: `نقوم بتهيئة موقعك لمحركات البحث بالتعديلات البرمجية الخاضعة للمعايير القياسية لمحركات 

البحث العالمية، ونعمل على إشهار وتسويق موقعك للوصول لأكبر عدد من العملاء.

`,
    trainT: `التدريب والتأهيل والتطوير المؤسسي
`,
    trainC: `تنظيم وإقامة دورات تدريبية للكادر الوظيفي لرفع مستوى الوعي لديه، من خلال مدرِّبين متخصِّصين في مجال الإدارة والتنمية البشرية.

`,
    whysection: `مايميزنا`,
    whyContentOne: `
تنفيذ خدمات إعلانية شاملة بأفكار مبتكرة وحلول 
دعائية متطورة وعملية، فعنصر الابتكار هو أهم ما يميزنا عن غيرنا، وتنفيذ مهامنا بإتقان وجودةتنفيذ خدمات اعلانية شاملة وبأفكار مبتكرة وحلول دعائية متطورة وعملية, فعنصر الأبتكار هو اهم ما يميزنا عن غيرنا, وتنفيذ مهامنا باتقان وجودة.

`,
    whyContentTwo: `وتمتد علاقتنا المتواصلة مع عملائنا إذ نعمل على تطوير أعمالهم من خلال تسويق وترويج شامل وفق أرقى الحلول التسويقية المتكاملة لتحقيق أفضل النتائج الترويجية، والتي تساهم في رفع عوائد استثماراتهموتمتد علاقتنا المتواصلة مع علائنا, اذ اعمل على تطوير اعمالهم من خلال تسويق وترويج شامل وفق أرقى الحلول التسويقية المتكاملة لتحقيق افضلالنتائج الترويجية, والتي تساهم في رفع عوائد استثماراتهم

`,
    thoughts: `أفكار ابداعية
`,
    solutions: `حلول احترافية شاملة
`,
    designContent: `محتوى وتصميم متميز
`,
    pro: `مهنية وكفاءة عالية
`,
    clientsSectionTitle: `عملائنا
`,
    footerNum: `778099900
`,
    footerLocalNum: `01 - 449 990
`,
    address: `صنعاء - شارع الجزائر
`,
    copyrights: `©2021 جميع الحقوق محفوظه
`,
};